import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from "react";
import { initZin } from "zin_sdk";
import { HotelShortVideosProperties } from "./hotel-short-videos.types";
const SHADOW_STYLE_ID = "hotel-short-videos-shadow-style";
const SHADOW_STYLE_CONTENT = `
  .story-title {
    color: var(--color-on-surface-high-emphasis, rgba(4, 10, 31, 0.87));
    font-size: 12px;
    font-weight: 400;
  }
`;
export const HotelShortVideos: React.FC<HotelShortVideosProperties> = t0 => {
  const $ = _c(17);
  const {
    displayType,
    displayId,
    className: t1,
    environment: t2,
    zinKey,
    zinTags
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const environment = t2 === undefined ? "prod" : t2;
  const containerReference = useRef(null);
  let t3;
  let t4;
  if ($[0] !== environment || $[1] !== zinKey || $[2] !== zinTags) {
    t3 = () => {
      initZin({
        env: environment,
        zinKey,
        zinTags
      });
    };
    t4 = [environment, zinKey, zinTags];
    $[0] = environment;
    $[1] = zinKey;
    $[2] = zinTags;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  useEffect(t3, t4);
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      const host = containerReference.current;
      if (!host) {
        return;
      }
      let shadowObserver = null;
      let stopped = false;
      const handleShadow = shadow => {
        if (!shadow.querySelector(`#${SHADOW_STYLE_ID}`)) {
          const style = document.createElement("style");
          style.id = SHADOW_STYLE_ID;
          style.textContent = SHADOW_STYLE_CONTENT;
          shadow.append(style);
        }
        const check = () => {
          if (stopped) {
            return;
          }
          const hidden = shadow.querySelector(".placement-container--hidden");
          if (hidden) {
            host.style.display = "none";
            shadowObserver?.disconnect();
            return;
          }
          const visibleContent = shadow.querySelector(".placement-container:not(.placement-container--hidden)");
          if (visibleContent) {
            host.style.minHeight = "auto";
            shadowObserver?.disconnect();
          }
        };
        shadowObserver = new MutationObserver(check);
        shadowObserver.observe(shadow, {
          childList: true,
          subtree: true
        });
        check();
      };
      if (host.shadowRoot) {
        handleShadow(host.shadowRoot);
      } else {
        const hostObserver = new MutationObserver(() => {
          if (host.shadowRoot) {
            hostObserver.disconnect();
            handleShadow(host.shadowRoot);
          }
        });
        hostObserver.observe(host, {
          childList: true
        });
        return () => {
          stopped = true;
          hostObserver.disconnect();
          shadowObserver?.disconnect();
        };
      }
      return () => {
        stopped = true;
        shadowObserver?.disconnect();
      };
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== displayId || $[7] !== zinTags) {
    t6 = [zinTags, displayId];
    $[6] = displayId;
    $[7] = zinTags;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  useEffect(t5, t6);
  const defaultHeight = displayType === "REELS" ? 322 : 142;
  let t7;
  if ($[9] !== defaultHeight) {
    t7 = {
      minHeight: defaultHeight,
      fontFamily: "var(--family-sans, IRANSansXFa), sans-serif"
    };
    $[9] = defaultHeight;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const t8 = `block overflow-hidden rounded ${className}`;
  let t9;
  if ($[11] !== displayId || $[12] !== displayType || $[13] !== t7 || $[14] !== t8 || $[15] !== zinTags) {
    t9 = <div ref={containerReference} key={zinTags} data-placement-type={displayType} id={displayId} style={t7} className={t8} />;
    $[11] = displayId;
    $[12] = displayType;
    $[13] = t7;
    $[14] = t8;
    $[15] = zinTags;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  return t9;
};